import request from "superagent";
import env from "../constants/env";
import { Auth } from "aws-amplify";

function sessionError(message, code) {
  return Object.assign(new Error(`${message} (${code})`), { code });
}

async function currentIdToken() {
  let session;
  try {
    // Cognito renews expired sessions here; app state can retain the ID token
    // from before an idle tab or the periodic credentials refresh.
    session = await Auth.currentSession();
  } catch (error) {
    const code = error && (error.code || error.name);
    const message = typeof error === "string" ? error : error && error.message;
    const missingSession = [
      "No current user",
      "Cannot retrieve a new session. Please authenticate.",
      "Local storage is missing an ID Token, Please authenticate",
      "Username is null. Cannot retrieve a new session"
    ].includes(message);
    if (code === "NotAuthorizedException" || missingSession) {
      throw sessionError("Sign in again before managing job chats.", "JOB_CHAT_AUTH_REQUIRED");
    }
    throw sessionError("Unable to refresh your sign-in session. Check your connection and try again.", "JOB_CHAT_SESSION_UNAVAILABLE");
  }
  const idToken = session && session.getIdToken && session.getIdToken();
  const jwt = idToken && idToken.getJwtToken && idToken.getJwtToken();
  if (typeof jwt !== "string" || !jwt.trim()) {
    throw sessionError("Sign in again before managing job chats.", "JOB_CHAT_AUTH_REQUIRED");
  }
  return jwt;
}

export async function jobChatRequest(action, body) {
  const jwt = await currentIdToken();
  try {
    const response = await request.post(`${env.apiGateway.baseUrl}/services/streamChat/jobChats/${action}`)
      .timeout({response:25000,deadline:27000})
      .set("Authorization", jwt).set("Accept", "application/json").send(body);
    return response.body;
  } catch (error) {
    const code = error.response && error.response.body && error.response.body.code;
    if (error.status === 401 && ["JOB_CHAT_AUTH_REQUIRED", "JOB_CHAT_AUTH_INVALID", "JOB_CHAT_AUTH_UNTRUSTED"].includes(code)) {
      throw sessionError("Your sign-in session was rejected. Sign in again, then retry.", code);
    }
    // Never replay a submitted archive/restore after an ambiguous response.
    // The existing signed continuation and explicit Resume own retry behavior.
    throw error;
  }
}
export const jobChatAccess = (orgId, instanceId, channelId = `instance-${instanceId}`) => jobChatRequest("access", { orgId, instanceId, channelId });
